//文字コードはutf-8

/* KV イントロアニメーション
 * 画像読み込み完了後に .topKv に is-loaded を付与し、
 * CSS 側のキーフレーム連鎖（見出し → サブ → para → 図版）を起動する。
 *
 * window.load を待つ理由:
 *   KV の <img> がまだ読み込まれていない状態でアニメーションが
 *   始まると、レイアウトシフトとイントロが重なって体感品質が下がるため。
 *
 * フォールバック: 1.6 秒経過しても load が来ない場合は強制的に開始。
========================================================*/

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const FALLBACK_MS = 1600;

export function initKvIntro() {
    const $kv = $('.topKv');
    if (!$kv.length) return;

    // モーション削減時は即座に最終状態
    if (REDUCED_MOTION) {
        $kv.addClass('is-loaded');
        return;
    }

    let started = false;
    const start = function () {
        if (started) return;
        started = true;
        // 1 フレーム遅らせて transition を確実に発火
        requestAnimationFrame(function () {
            $kv.addClass('is-loaded');
        });
    };

    // 既に load 済みなら即時、まだなら load を待つ
    if (document.readyState === 'complete') {
        start();
    } else {
        $(window).one('load', start);
        // 安全網
        setTimeout(start, FALLBACK_MS);
    }
}
